import React from 'react';

const NotEligible = ({ hcp }) => {
  return (
    <div className="not-eligible-alert">
      <img src="/images/checkmark-x.png" alt="X icon" />
      <div>
        <h4 className="poppins-regular">
          Unfortunately, {hcp ? 'your patient is' : 'you are'}{' '}
          <b>not eligible</b> to&nbsp;participate in this program.
        </h4>
        <p className="poppins-regular">
          Please contact <b>Takeda Oncology Here2Assist</b> at{' '}
          <b>1&#8209;844&#8209;817&#8209;6468, Option 2, Monday&#8209;Friday, 8AM-8PM ET.</b>
        </p>
      </div>
    </div>
  );
};

export default NotEligible;
